import { Component, inject, signal } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { TranslatePipe } from '@ngx-translate/core';
import { filter, interval, tap } from 'rxjs';

import { ClButton } from '@corelabs/angular/ui';
import { IconComponent } from '@shared/components';

const CHECK_INTERVAL = 5 * 60 * 1000;

/** Bottom bar offering a reload once the service worker has a newer build ready. */
@Component({
    selector: 'app-update-notifier',
    templateUrl: './update-notifier.component.html',
    styleUrls: ['./update-notifier.component.css'],
    imports: [ClButton, IconComponent, TranslatePipe],
})
export class UpdateNotifierComponent {
    private readonly swUpdate = inject(SwUpdate);

    readonly ready = signal(false);

    constructor() {
        // Disabled in dev and on non-service-worker builds, where checkForUpdate() rejects.
        if (!this.swUpdate.isEnabled) {
            return;
        }

        // The worker only checks on registration; this keeps long-lived tabs current too.
        interval(CHECK_INTERVAL)
            .pipe(tap(() => this.swUpdate.checkForUpdate()))
            .subscribe();

        this.swUpdate.versionUpdates
            .pipe(
                filter((event) => event.type === 'VERSION_READY'),
                tap(() => this.ready.set(true)),
            )
            .subscribe();
    }

    reload(): void {
        window.location.reload();
    }
}
